<template>
  <Modal
    name="INVALIDATE_ITEM_DEFAULT_SERVICE_VALUES"
    :title="$t('inactiveModal.title')"
    actions
  >
    <template v-slot:body>
      <h3 class="red--text mb-2">Esta é uma ação sem volta.</h3>
      <p class="body-2">
        {{ $t('inactiveModal.question') }}
      </p>

      <v-card class="pa-5" color="grey lighten-4" elevation="0">
        <v-row no-gutters>
          <v-col cols="12" sm="9">
            <h6 class="text-uppercase grey--text">
              {{ $t('defaultServiceValues.label.serviceType') }}
            </h6>
            <p class="body-2">
              {{
                defaultServiceValue.type
                  ? $t(`type.${defaultServiceValue.type}`)
                  : '---'
              }}
            </p>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" sm="3">
            <h6 class="text-uppercase grey--text">
              {{ $t('defaultServiceValues.label.contract') }}
            </h6>
            <p class="mb-0 body-2">
              {{
                defaultServiceValue.contract_type
                  ? $t(`paymentTypes.${defaultServiceValue.contract_type}`)
                  : '---'
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="3">
            <h6 class="text-uppercase grey--text">
              {{ $t('defaultServiceValues.label.price') }}
            </h6>
            <p class="mb-0 body-2">
              {{
                defaultServiceValue.price
                  ? monetaryFormat(defaultServiceValue.price)
                  : '---'
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="4">
            <h6 class="text-uppercase grey--text">
              {{ $t('defaultServiceValues.label.dateCreated') }}
            </h6>
            <p class="mb-0 body-2">
              {{
                defaultServiceValue.date_created
                  ? dateFormat(defaultServiceValue.date_created)
                  : '---'
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="2">
            <h6 class="text-uppercase grey--text">
              {{ $t('defaultServiceValues.label.status') }}
            </h6>
            <p class="mb-0 body-2">
              {{
                defaultServiceValue.is_active
                  ? $t(`defaultServiceValues.label.active`)
                  : $t(`defaultServiceValues.label.inactive`)
              }}
            </p>
          </v-col>
        </v-row>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isLoading"
        elevation="0"
        color="primary"
        outlined
        dark
      >
        {{ $t('inactiveModal.buttons.cancel') }}
      </v-btn>
      <v-btn
        @click="inactivate"
        :loading="isLoading"
        elevation="0"
        class="ml-5"
        color="red"
        dark
      >
        {{ $t('inactiveModal.buttons.inactivate') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { catalogMonetary, catalogDate } from '@/util/catalog'
import Modal from '@/components/app/Modal'

export default {
  name: 'InactivateDefaultServiceValuesModal',

  components: {
    Modal,
  },

  data() {
    return {
      dateFormat: catalogDate,
      monetaryFormat: catalogMonetary,
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'defaultServiceValue']),
  },

  methods: {
    ...mapActions(['inactivateDefaultServiceValue']),
    ...mapMutations(['closeAllModals']),

    inactivate() {
      this.inactivateDefaultServiceValue()
    },
  },
}
</script>
